module.exports = __webpack_public_path__ + "static/img/hover-iocn8.7cf8886.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn8.svg
// module id = riyq
// module chunks = 3